function initFacetsCardDeckEvents() {
  const deck = document.getElementById('FacetsCardDeck');
  if (!deck || deck.dataset.facetsDeckInitialized === 'true') return;
  deck.dataset.facetsDeckInitialized = 'true';

  deck.addEventListener('click', (event) => {
    const item = event.target.closest('.facets-card-deck__filter__item');
    if (!item || !deck.contains(item)) return;

    const filterGroup = item.closest('.facets-card-deck__filter');
    if (!filterGroup) return;

    const filterType = filterGroup.dataset.type;
    const filterValue = item.dataset.value;
    const isCardDeckFilterEnabled = document.querySelector('.collection-product-grid')?.classList.contains('card-deck-filter-enabled') || false;

    if (item.classList.contains('is-active') && filterGroup.classList.contains('is-removable')) {
      if (isCardDeckFilterEnabled) {
        // filter facets: cascade — uncheck this filter and all subsequent set filters
        const orderedTypes = ['sex', 'sport', 'type'];
        const form = document.querySelector('facet-filters-form form');
        if (form) {
          let triggerInput = null;
          orderedTypes.slice(orderedTypes.indexOf(filterType)).forEach((t) => {
            form.querySelectorAll(`input[type="checkbox"][data-filter="${t}"]:checked`).forEach((cb) => {
              cb.checked = false;
              if (!triggerInput) triggerInput = cb;
            });
          });
          if (triggerInput) triggerInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      } else {
        const facetRemove = document.querySelector(`#FacetRemove-${filterType}-${filterValue} a`);
        if (facetRemove) facetRemove.click();
      }
    } else if (isCardDeckFilterEnabled && filterGroup.classList.contains('is-set') && filterGroup.classList.contains('is-active') && item.classList.contains('is-active')) {
      // filter card deck: tapping the already-selected type item deselects it
      const facetRemove = document.querySelector(`#FacetRemove-${filterType}-${filterValue} a`);
      if (facetRemove) {
        facetRemove.click();
      }
    } else if (filterGroup.classList.contains('is-active')) {
      const form = document.querySelector('facet-filters-form form');
      if (isCardDeckFilterEnabled) {
        // filter card deck: single selection — clear any existing selection for this type first
        form.querySelectorAll(`input[type="checkbox"][data-filter="${filterType}"]:checked`).forEach((cb) => {
          cb.checked = false;
        });
        const checkbox = form.querySelector(`input[type="checkbox"][data-filter="${filterType}"][value="${filterValue}"]`);
        if (checkbox) {
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('input', { bubbles: true }));
        }
      } else {
        const checkbox = form.querySelector(`input[type="checkbox"][data-filter="${filterType}"][value="${filterValue}"]`);
        if (checkbox && !checkbox.checked) {
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    }
  });
}

function updateFacetsCardDeckStates() {
  const deck = document.getElementById('FacetsCardDeck');
  if (!deck) return;

  const orderedTypes = ['sex', 'sport', 'type'];
  const filterElements = {};

  orderedTypes.forEach((type) => {
    filterElements[type] = deck.querySelector(`#FacetsCardDeckFilter-${type}`);
  });

  const isSetByType = {};
  const activeValuesByType = {};
  orderedTypes.forEach((type) => {
    const inputs = Array.from(document.querySelectorAll(`input[type="checkbox"][data-filter="${type}"]`));
    const checkedInputs = inputs.filter((input) => input.checked);
    activeValuesByType[type] = checkedInputs.map((input) => input.value);
    let isSet = checkedInputs.length > 0;
    if (!isSet && inputs.length === 0 && filterElements[type] && filterElements[type].dataset.set) {
      isSet = filterElements[type].dataset.set === 'true';
    }
    isSetByType[type] = isSet;
    if (filterElements[type]) {
      filterElements[type].dataset.set = isSet;
    }
  });

  const collectionId = deck.dataset.collection || 'default';
  const storageKey = `facetsSetOrder-${collectionId}`;
  let setOrder = [];
  try {
    const stored = sessionStorage.getItem(storageKey);
    if (stored) {
      setOrder = JSON.parse(stored).filter((type) => orderedTypes.includes(type));
    }
  } catch (e) {
    setOrder = [];
  }

  const currentSetTypes = orderedTypes.filter((type) => isSetByType[type]);
  setOrder = setOrder.filter((type) => isSetByType[type]);
  currentSetTypes.forEach((type) => {
    if (!setOrder.includes(type)) {
      setOrder.push(type);
    }
  });

  try {
    sessionStorage.setItem(storageKey, JSON.stringify(setOrder));
  } catch (e) {
    // Ignore storage errors (private mode, etc.)
  }

  const displayOrder = [
    ...setOrder,
    ...orderedTypes.filter((type) => !isSetByType[type]),
  ];
  const lastSetType = setOrder[setOrder.length - 1] || null;
  const isCardDeckFilterEnabled = document.querySelector('.collection-product-grid')?.classList.contains('card-deck-filter-enabled') || false;
  const lastOrderedType = orderedTypes[orderedTypes.length - 1];
  const secondToLastSetType = isCardDeckFilterEnabled && setOrder.length >= 2 ? setOrder[setOrder.length - 2] : null;
  const removableType = isCardDeckFilterEnabled
    ? (lastSetType === lastOrderedType ? secondToLastSetType : lastSetType)
    : lastSetType;

  let activeAssigned = false;
  displayOrder.forEach((type) => {
    const element = filterElements[type];
    if (!element) return;

    element.classList.remove('is-set', 'is-active', 'is-hidden', 'is-removable');
    if (isSetByType[type]) {
      element.classList.add('is-set');
      if (isCardDeckFilterEnabled && type === lastSetType && type === lastOrderedType) {
        element.classList.add('is-active');
      } else if (type === removableType) {
        element.classList.add('is-removable');
      }
    } else if (!activeAssigned) {
      element.classList.add('is-active');
      activeAssigned = true;
    } else {
      element.classList.add('is-hidden');
    }

    const activeValues = activeValuesByType[type] || [];
    element.querySelectorAll('.facets-card-deck__filter__item').forEach((item) => {
      item.classList.toggle('is-active', activeValues.includes(item.dataset.value));
      const labelCountSpan = document.querySelector(`.mobile-facets__details[data-filter="${item.dataset.type}"] .mobile-facets__list li[data-label="${item.dataset.value}"] .label-span`);
      if (labelCountSpan) {
        const count = Number(labelCountSpan.dataset.count);
        if (count <= 0) {
          item.classList.add('is-disabled');
        } else {
          item.classList.remove('is-disabled');
        }
      }
    });

    deck.appendChild(element);
  });

  deck.dataset.scrollHintRetries = '0';

  document.querySelectorAll('.mobile-facets__details').forEach((details) => {
    const label = details.querySelector('.mobile-facets__label-text[data-active-values-size]');
    if (!label) return;

    let activeValuesSize = details.querySelectorAll('input[type="checkbox"]:checked').length;
    if (activeValuesSize === 0) {
      const rangeInputs = Array.from(details.querySelectorAll('input[type="number"]'));
      if (rangeInputs.length) {
        activeValuesSize = rangeInputs.filter((input) => input.value !== '').length;
      }
    }
    label.dataset.activeValuesSize = activeValuesSize;
  });

  initActiveFilterScrollHints();
}

function setupActiveFilterScrollHintObserver() {
  const deck = document.getElementById('FacetsCardDeck');
  if (!deck || deck.dataset.scrollHintObserverInitialized === 'true') return;
  deck.dataset.scrollHintObserverInitialized = 'true';

  const observer = new MutationObserver((mutations) => {
    const hasRelevantChange = mutations.some((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        return mutation.target.classList.contains('facets-card-deck__filter');
      }
      if (mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)) {
        return true;
      }
      return false;
    });
    if (hasRelevantChange) {
      initActiveFilterScrollHints();
    }
  });

  observer.observe(deck, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class'],
  });

  if (!FacetFiltersForm.scrollHintLoadListenerInitialized) {
    FacetFiltersForm.scrollHintLoadListenerInitialized = true;
    window.addEventListener('load', () => {
      initActiveFilterScrollHints();
    });
  }
}

function initActiveFilterScrollHints() {
  const activeFilters = document.querySelectorAll('.facets-card-deck');
  activeFilters.forEach((element) => {
    if (element.dataset.scrollHintDone === 'true' || element.dataset.scrollHintObserved === 'true') return;
    if (element.scrollWidth <= element.clientWidth + 1) {
      if (element.dataset.scrollHintPending !== 'true') {
        const retries = parseInt(element.dataset.scrollHintRetries || '0', 10);
        if (retries >= 3) return;
        element.dataset.scrollHintRetries = String(retries + 1);
        element.dataset.scrollHintPending = 'true';
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            element.dataset.scrollHintPending = 'false';
            initActiveFilterScrollHints();
          });
        });
        setTimeout(initActiveFilterScrollHints, 300);
      }
      return;
    }

    if (!('IntersectionObserver' in window)) {
      triggerActiveFilterScrollHint(element);
      return;
    }

    element.dataset.scrollHintObserved = 'true';
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        triggerActiveFilterScrollHint(element);
        obs.unobserve(element);
      });
    }, { threshold: 0.6 });
    observer.observe(element);
  });
}

function triggerActiveFilterScrollHint(element) {
  if (element.dataset.scrollHintDone === 'true') return;
  element.dataset.scrollHintDone = 'true';

  const maxScroll = element.scrollWidth - element.clientWidth;
  if (maxScroll <= 0) return;

  const offset = Math.min(100, maxScroll);
  const start = element.scrollLeft;
  setTimeout(() => {
    element.scrollTo({ left: start + offset, behavior: 'smooth' });
    setTimeout(() => {
      element.scrollTo({ left: start, behavior: 'smooth' });
    }, 500);
  }, 500);
}

function clearFacetInputs(removeScope, removeFilter, removeValue) {
  const root = document;
  const clearCheckboxes = (inputs) => {
    inputs.forEach((input) => {
      if (input.checked) input.checked = false;
      input.classList.remove('checked-ryzon');
    });
  };
  const clearRangeInputs = (containers) => {
    containers.forEach((container) => {
      container.querySelectorAll('input[type="number"]').forEach((input) => {
        if (input.value !== '') input.value = '';
      });
    });
  };

  if (removeScope === 'all') {
    clearCheckboxes(Array.from(root.querySelectorAll('input[type="checkbox"]')));
    clearRangeInputs([root]);
    return;
  }

  if (removeScope === 'filter' && removeFilter) {
    const inputs = Array.from(root.querySelectorAll('input[type="checkbox"][data-filter]'))
      .filter((input) => input.dataset.filter === removeFilter);
    clearCheckboxes(inputs);
    const containers = Array.from(root.querySelectorAll(`.js-filter[data-filter="${removeFilter}"], .mobile-facets__details[data-filter="${removeFilter}"]`));
    clearRangeInputs(containers);
    return;
  }

  if (removeScope === 'value' && removeFilter && removeValue) {
    const inputs = Array.from(root.querySelectorAll('input[type="checkbox"][data-filter]'))
      .filter((input) => input.dataset.filter === removeFilter && input.value === removeValue);
    clearCheckboxes(inputs);
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    updateTeaserCards(window.location.search.slice(1));
    FacetFiltersForm.extractSexFilter(window.location.search.slice(1), Date.now());
    updateFacetsCardDeckStates();
    setupActiveFilterScrollHintObserver();
    initFacetsCardDeckEvents();
  }

  static setListeners() {
    if (FacetFiltersForm.listenersInitialized) return;
    FacetFiltersForm.listenersInitialized = true;
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, searchParams);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event, searchParams);
      }
    
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  static renderSectionFromFetch(url, event, searchParams) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (event.target.getAttribute('name') && event.target.getAttribute('name') == 'filter.v.m.filter.gender') {
          FacetFiltersForm.extractSexFilter(searchParams, Date.now());
        }
        updateTeaserCards(searchParams);
        updateFacetsCardDeckStates();
      });
  }

  static renderSectionFromCache(filterDataUrl, event, searchParams) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (event.target.getAttribute('name') && event.target.getAttribute('name') == 'filter.v.m.filter.gender') {
      FacetFiltersForm.extractSexFilter(searchParams, Date.now());
    }
    updateTeaserCards(searchParams);
    updateFacetsCardDeckStates();
    initLazyload();
  }

  static extractSexFilter(searchParams, timestamp) {
    if (FacetFiltersForm.extractSexFilter.last && timestamp - FacetFiltersForm.extractSexFilter.last < 1000) return;
    FacetFiltersForm.extractSexFilter.last = timestamp;
    
    const sexFilters = new URLSearchParams(searchParams).getAll('filter.v.m.filter.gender');
    if (sexFilters.length > 1) {
        updateUserFocusView('unisex');
    } else if (sexFilters.length == 1) {
        updateUserFocusView(sexFilters[0]);
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    dynamicHoverImageLoader();
  }

  static renderProductCount(html) {
    const productCountElement = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    if (productCountElement) {
      const count = productCountElement.innerHTML;
      const container = document.getElementById('ProductCount');
      const containerDesktop = document.getElementById('ProductCountDesktop');
      container.innerHTML = count;
      container.classList.remove('loading');
      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
    }
    setTimeout(() => {
      initLazyload();
    }, 500);
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    if (document.getElementById('FacetFiltersFormMobile')) {
      document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    var searchParam = new URLSearchParams(new FormData(form)).toString();
    var searchParamWithoutDuplicates = '';
    searchParam.split('&').forEach((searchParamSplit) => {
      if (searchParamWithoutDuplicates.indexOf(searchParamSplit) == -1) {
        searchParamWithoutDuplicates = searchParamWithoutDuplicates + '&' + searchParamSplit;
      }
    });
    searchParamWithoutDuplicates = searchParamWithoutDuplicates.substring(1, searchParamWithoutDuplicates.length);
    return searchParamWithoutDuplicates;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    // Set available filter
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      var availableInput = document.getElementById('Filter-Verfügbarkeit-mobile-1');
      var notAvailableInput = document.getElementById('Filter-Verfügbarkeit-mobile-2');
    } else {
      var availableInput = document.getElementById('Filter-Verfügbarkeit-1');
      var notAvailableInput = document.getElementById('Filter-Verfügbarkeit-2');
    }
    if (availableInput && availableInput != event.target && availableInput.checked == false && notAvailableInput.checked == false) {
      availableInput.checked = true;
    }

    // Set checked-ryzon classes to identify dynamic changes of checkbox
    if (event.target) {
      if (event.target.checked == true) {
        datalayer_push_filter('filter_usage', event.target.dataset.filter, event.target.value);
        event.target.classList.add('checked-ryzon');
        //let resetButton = document.querySelector('.facets__reset[data-filter="' + event.target.dataset.filter + '"]');
        let resetButton = document.querySelector('#show-all-sports');
        if (resetButton) {
          resetButton.classList.remove('checked-ryzon');
        }
      } else {
        event.target.classList.remove('checked-ryzon');
      }
    }

    if (event.target.id == 'SortBy' || event.target.id == 'SortBy-mobile') {
      datalayer_push_filter('sort_usage', 'sort_by', event.target.value);
    }
    event.preventDefault();

    if (document.body.classList.contains('ryz-90') && event.target.getAttribute('name') == 'filter.v.m.filter.gender') {
      const form = event.target.closest('form');
      const menCheckbox = form.querySelector('.desktop-facets__details[data-filter="sex"] input[type="checkbox"][value="men"]');
      const womenCheckbox = form.querySelector('.desktop-facets__details[data-filter="sex"] input[type="checkbox"][value="women"]');
      if (event.target.value == 'women') {
        menCheckbox.checked = false;
        menCheckbox.classList.remove('checked-ryzon');
      } else {
        womenCheckbox.checked = false;
        womenCheckbox.classList.remove('checked-ryzon');
      }
    }

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url, event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.lastRemoveScope = '';
FacetFiltersForm.lastRemoveFilter = '';
FacetFiltersForm.listenersInitialized = false;
FacetFiltersForm.scrollHintLoadListenerInitialized = false;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    FacetFiltersForm.lastRemoveScope = this.dataset.removeScope || '';
    FacetFiltersForm.lastRemoveFilter = this.dataset.filter || '';
    clearFacetInputs(
      FacetFiltersForm.lastRemoveScope,
      FacetFiltersForm.lastRemoveFilter,
      this.dataset.value || ''
    );
    updateFacetsCardDeckStates();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
